import { Instagram } from "lucide-react";

const TikTokIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.88-2.88 2.89 2.89 0 012.88-2.88c.3 0 .59.05.86.12V9.01a6.32 6.32 0 00-.86-.06 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.34-6.34V8.75a8.28 8.28 0 004.76 1.5V6.8a4.84 4.84 0 01-1-.11z" />
  </svg>
);

const FacebookIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
  </svg>
);

const YouTubeIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814z" />
    <polygon fill="white" points="9.545,15.568 15.818,12 9.545,8.432" />
  </svg>
);

const socials = [
  { href: "https://www.instagram.com/justjjax/", label: "@justjjax", icon: Instagram, color: "hover:text-pink-500" },
  { href: "https://www.instagram.com/lazyelley/", label: "@lazyelley", icon: Instagram, color: "hover:text-pink-500" },
  { href: "https://tiktok.com/@Just_jjax", label: "@Just_jjax", icon: TikTokIcon, color: "hover:text-charcoal" },
  { href: "https://www.facebook.com/profile.php?id=61550018370626", label: "Facebook", icon: FacebookIcon, color: "hover:text-blue-600" },
  { href: "https://www.youtube.com/@JustJJax", label: "YouTube", icon: YouTubeIcon, color: "hover:text-red-500", comingSoon: true },
];

export default function SocialBar() {
  return (
    <div className="fixed right-0 top-1/2 -translate-y-1/2 z-[55] flex flex-col gap-3 bg-charcoal/90 backdrop-blur-sm rounded-l-2xl py-4 px-2.5" data-testid="social-bar">
      {socials.map((s) =>
        s.comingSoon ? (
          <span
            key={s.label}
            className="flex items-center justify-center w-9 h-9 rounded-xl bg-white/10 text-white/40 cursor-default"
            data-testid={`social-bar-${s.label.replace(/[@ .]/g, "").toLowerCase()}`}
            title={`${s.label} — coming soon`}
          >
            <s.icon size={18} />
          </span>
        ) : (
          <a
            key={s.label}
            href={s.href}
            target="_blank"
            rel="noopener noreferrer"
            className={`flex items-center justify-center w-9 h-9 rounded-xl bg-white/10 text-white/80 ${s.color} transition-all duration-300 hover:scale-110 hover:bg-white/20`}
            data-testid={`social-bar-${s.label.replace(/[@ .]/g, "").toLowerCase()}`}
            title={s.label}
          >
            <s.icon size={18} />
          </a>
        )
      )}
    </div>
  );
}
